import { render, staticRenderFns } from "./WebinariDani15.vue?vue&type=template&id=26936297&scoped=true&"
import script from "./WebinariDani15.vue?vue&type=script&lang=js&"
export * from "./WebinariDani15.vue?vue&type=script&lang=js&"
import style1 from "./WebinariDani15.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26936297",
  null
  
)

export default component.exports